var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovePrimaryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#FDFDFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.27398L11.7273 3.33398L8.00065 7.06065L4.27398 3.33398L3.33398 4.27398L7.06065 8.00065L3.33398 11.7273L4.27398 12.6673L8.00065 8.94065L11.7273 12.6673L12.6673 11.7273L8.94065 8.00065L12.6673 4.27398Z",
    fill: "#508CC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePrimaryWhite);
export default __webpack_public_path__ + "static/media/remove_primary_white.fc1ad24ca8353c22d74dcb7ca5c832af.svg";
export { ForwardRef as ReactComponent };